exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{font-family:Montserrat,sans-serif!important}.support-tools__warning{padding:10px;text-align:center;background-color:#ffdf8d;border-radius:8px!important;color:#ff445d}.full-width{width:100%!important}.spacing-bottom{margin-bottom:8px}ul{list-style:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d741f30","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/support/supportItems/switchWorkShiftToSchedule.vue
// module id = 1229
// module chunks = 0